import Render from '@Views/components/layout/master.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Master extends Vue {
}